import React from 'react'
import { useIntl } from 'react-intl'

import { Modal } from '@slite/components'

const DEMO_SUPER_YOUTUBE_VIDEO_ID = 'JNXFSjguDWE'

export const DemoVideoModal = ({
  isOpen,
  setIsOpen,
  youtubeVideoId = DEMO_SUPER_YOUTUBE_VIDEO_ID,
}: {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  youtubeVideoId?: string
}) => {
  const intl = useIntl()
  const videoUrl = `https://www.youtube.com/embed/${youtubeVideoId}?rel=0&autoplay=1&cc_load_policy=0`
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      size={1200}
      shouldCloseOnEsc
      className="flexbox flexbox-centered"
      // The website navbar is fixed with zIndex 1000; the Modal default (4)
      // would leave it floating above the overlay.
      overlayStyle={{ zIndex: 1100 }}
    >
      <div
        style={{
          left: 0,
          width: '100%',
          height: 0,
          position: 'relative',
          paddingBottom: 'calc(min(67.7%, 85vh))',
          maxWidth: '85vw',
          borderRadius: 20,
        }}
        className=" shadow-large overflow-hidden background-super-space-dark transition"
      >
        <iframe
          src={videoUrl}
          style={{
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            position: 'absolute',
            border: 0,
          }}
          allowFullScreen
          allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
          title={intl.formatMessage({
            id: 'super.feature.video.title',
            defaultMessage: 'Super Feature Video',
          })}
        ></iframe>
      </div>
    </Modal>
  )
}
